var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.2 391.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #333;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.2,184.2v14.5c-4.6,18-30.1,17.5-32.7-1.3s-1.1-24.8-4.3-38.5C330.3,54.2,210.8.5,116.3,53.4,33.1,99.9,6.8,207.7,60.8,287.1c53.3,78.4,163.4,95.2,237.2,35l-19.6-20.1c-13.8,7.6-31.3,3.4-45.4-2-52.3-20.3-130.6-98.9-150.4-151.5-9.1-24.1-8.6-35.7,7.8-55.2s24.3-24.6,44.7-14.1c18,9.2,41.4,33.8,36.5,55.6-3.1,13.4-16.7,21.1-8.8,35.2s9.8,12.7,13.2,16.6c7.3,8.2,30.6,31.4,39.7,35.2,13,5.4,21.9-9.1,35.3-10.6,18.1-2.2,36.6,13.5,46.8,27.2s13.7,21.8,8.4,36.4c-.9,2.4-3.5,4.2-2.5,6.6,8.8,10.1,20.9,18.5,29.5,28.7,13.5,16-.4,26.1-12.7,36.3-26.1,21.6-59.9,37.2-93.5,42.6l-20,2.5c-7.6-.3-15.4.4-22.9,0C12.2,381.4-64.2,166.7,64.4,50.4c121.7-110,317.6-28.5,326.8,133.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone_call.a121929cb9bbab72503afc690b82b384.svg";
export { ForwardRef as ReactComponent };